module.exports = __webpack_public_path__ + "img/wt.b0a08a50.jpg";